import type { FlashcardsFeRouterCtx } from './flashcards-fe.router-ctx'

export function pageRouteParams(ctx: Pick<FlashcardsFeRouterCtx, 'spaces'>, spaceId: string, pageId: string) {
  return { workspaceId: ctx.spaces.get(spaceId).space.workspaceId, spaceId, pageId }
}
